import { Dialog, Transition } from '@headlessui/react'
import { Children, Fragment, useState } from 'react'
import { useTheme } from '../../ThemeContext'


export default function MyModal({className, children, isOpen, closeModal}) {
  // let [isOpen, setIsOpen] = useState(true)

  // function closeModal() {
  //   setIsOpen(false)
  // }

  // function openModal() {
  //   setIsOpen(true)
  // }
  const {isDarkMode} = useTheme()

  return (
    <>
      {/* <div className="fixed inset-0 flex items-center justify-center">
        <button
          type="button"
          // onClick={openModal}
          onClick={isOpen}
          className="rounded-md bg-black/20 px-4 py-2 text-sm font-medium text-white hover:bg-black/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75"
        >
          Open dialog
        </button>
      </div> */}

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" 
        onClose={closeModal}
        // onClose={isOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div style={{
              backdropFilter: "blur(8px)"
            }} className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className={`flex min-h-full items-center justify-center p-4 text-center  ${isDarkMode ? "bg-[#ffffff7a]" : "bg-[#00000080]"}`}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`11w-full transform overflow-hidden rounded-2xl bg-white 11p-6 text-left align-middle shadow-xl transition-all   ${className}  ${isDarkMode ? "dark-theme" : "light-theme"}`}>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
